var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    { staticClass: "rowBackgroundHomepage", class: _vm.customPageClass },
    [
      _c(
        "b-container",
        {
          staticClass: "ml-2 mr-2 mb-2 m-auto",
          class: { customContainer: !_vm.noReduce },
          attrs: { fluid: "" },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "p-0 m-auto",
                  attrs: {
                    md: _vm.colWidth,
                    "offset-md": (12 - _vm.colWidth) / 2,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "panel21 panel-default shadow",
                      class: _vm.smallPanel,
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "panel-heading d-flex justify-content-start mb-10px ml-1",
                        },
                        [
                          _c("div", { staticClass: "formTitleBlock" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "content-block labelAccordionForm justify-content-center panel-title",
                              },
                              [
                                _vm._t("titleContent", function () {
                                  return [
                                    _c("span", { staticClass: "fs-30px" }, [
                                      _vm._v(_vm._s(_vm.title)),
                                    ]),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.mandatoryIndication
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "content-block italicMandatoryIndication",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.asterisk_obligation_label"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("pageContent"),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("underPanel"),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("footerButtons"),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "pb-10px" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "xs-12 text-center" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center text-light",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ml-2",
                          staticStyle: { "font-size": "22px" },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.copyright")))]
                      ),
                      _vm._v(" \n          "),
                      _c("span", [_vm._v(_vm._s(_vm.version))]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }